.groups
  each group in groups
    .group
      each match in group
        .group-match
